import './index.css';

import React, {lazy, Suspense} from 'react';

import AiAssistantWidget from './components/AiAssistant/AiAssistantWidget';
import AppContainer from './components/AppContainer/AppContainer';
import AppLoader from './components/Loader/AppLoader.jsx';
import Logs from './components/Logs/Logs';
import NavigationBar from './components/NavigationBar/NavigationBar';
import envVariables from './consts/envVariables';
import DeviceControllers from './containers/DeviceControllers/DeviceControllers';
import LoaderGlobal from './containers/LoaderGlobal/LoaderGlobal';
import useAppVisibilityHandler from './hooks/useAppVisibilityHandler.js';
import useAwsRum from './hooks/useAwsRum';
import useBeforeInstallPromptHandler from './hooks/useBeforeInstallPromptHandler';
import useCompleteFirstMilestone from './hooks/useCompleteFirstMilestone';
import useHideNetworkNotifications from './hooks/useHideNetworkNotifications';
import {useHistoryScrollTop} from './hooks/useHistoryScrollTop';
import useInitApp from './hooks/useInitApp';
import useInitializeTheme from './hooks/useInitializeTheme';
import useIOSSafariFixes from './hooks/useIOSSafariFixes';
import useLogAppInfo from './hooks/useLogAppInfo';
import useLogNavigation from './hooks/useLogNavigation';
import useLoyaltyData from './hooks/useLoyaltyData';
import useManualNavigate from './hooks/useManualNavigate';
import useOfflineDetect from './hooks/useOfflineDetect';
import usePageInteraction from './hooks/usePageInteraction';
import usePrepareHead from './hooks/usePrepareHead';
import usePrepareTemplate from './hooks/usePrepareTemplate';
import usePWAStatusTracker from './hooks/usePWAStatusTracker';
import useRetail from './hooks/useRetail';
import useSWMessageHandler from './hooks/useSWMessageHandler';
import useSyncImportantRequests from './hooks/useSyncImportantRequests';
import useSyncOnlineRequests from './hooks/useSyncOnlineRequests';
import useThemeOverride from './hooks/useThemeOverride';

const Notifications = lazy(() => import('./components/Notifications/Notifications'));
const ModalsRoot = lazy(() => import('./containers/Modals/ModalsRoot'));
const AppRoutes = lazy(() => import('./containers/Routes/AppRoutes'));

const App = () => {
    useInitApp();
    useOfflineDetect();
    useManualNavigate();
    useHistoryScrollTop();
    useHideNetworkNotifications();
    useAwsRum();
    usePWAStatusTracker();
    useSWMessageHandler();
    useAppVisibilityHandler();
    useBeforeInstallPromptHandler();
    usePrepareTemplate();
    usePrepareHead();
    useSyncOnlineRequests();
    useSyncImportantRequests();
    useLogNavigation();
    useInitializeTheme();
    useLogAppInfo();
    usePageInteraction();
    useLoyaltyData();
    useRetail();
    useIOSSafariFixes();
    useCompleteFirstMilestone();
    useThemeOverride();

    return (
        <AppContainer>
            <Suspense fallback={<AppLoader />}>
                <AppRoutes />
                <Notifications />
                <NavigationBar />
                <AiAssistantWidget />
                <LoaderGlobal />
                <ModalsRoot />
                <DeviceControllers />
                {envVariables.ENV !== 'prd' && <Logs />}
            </Suspense>
        </AppContainer>
    );
};

export default App;
